import { debounce } from 'lodash';
import { useCallback } from 'react';

export const useDebounce = <F extends (...args: any[]) => any | void>(fn: F, delay: number) =>
  useCallback(debounce(fn, delay), []);
